import { themeVariants } from "@made-people/blueprint-component-wrapper/blueprint";

themeVariants.override({
  slots: {
    wrapper: "",
  },
  variants: {
    background: {
      primary: { wrapper: "bg-primary py-8 lg:py-16" },
      secondary: { wrapper: "bg-secondary py-8 lg:py-16" },
      black: { wrapper: "bg-black py-8 lg:py-16" },
      white: { wrapper: "bg-white py-8 lg:py-16" },
      grey: { wrapper: "bg-grey py-8 lg:py-16" },
      "surface-1": { wrapper: "bg-surface-1 py-8 lg:py-6" },
      "surface-2": { wrapper: "bg-surface-2 py-8 lg:py-6" },
      "surface-3": { wrapper: "bg-surface-3 py-8 lg:py-6" },
    },
  },
});
